import { Box, Spacer } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import { ReactElement, useEffect, useState } from 'react'
import { useWindowDimensions as useRNWindowDimensions } from 'react-native'
import ReactDOM from 'react-dom'
import ActionsMenu from '../../comps/ActionMenu/ActionsMenu'
import EmptyView from '../../comps/EmptyView'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { NewTable } from '../../comps/NewTable'
import { campaignsTitleData } from '../../data/static/data'
import { transactionScreenStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { getCustomColumnWidth, useWindowDimensions } from '../../util/util'
import { CampaignDetails } from '../CampaignDetails'
import CreateCampaign from '../CreateCampaign'
import { CampaignHighlights } from './CampaignHighlights'
import { styles } from './styles'

const Campaigns = () => {
  const path = useRoute().name
  const viewPortWidth = useWindowDimensions()

  const {
    getCampaigns,
    fetchCampaigns,
    mid,
    fetchCampaignsSummary,
    getMasterList,
    allPaymentModes,
    summary,
    selectedDateInfo,
    updateSelectedDate,
    fetchCampaignDetails,
  } = useStores((store) => ({
    mid: store.user.selectedMid,
    getCampaigns: store.campaigns.getCampaigns,
    fetchCampaigns: store.campaigns.fetchCampaigns,
    fromDate: store.campaigns.selectedDateInfo.fromDate,
    toDate: store.campaigns.selectedDateInfo.toDate,
    resetPaymentModes: store.campaigns.resetPaymentModes,
    fetchCampaignsSummary: store.campaigns.fetchCampaignsSummary,
    getMasterList: store.campaigns.getPaymentModesMasterList,
    allPaymentModes: store.campaigns.paymentModes,
    selectedDateInfo: store.campaigns.selectedDateInfo,
    updateSelectedDate: store.campaigns.updateSelectedDateInfo,
    summary: store.campaigns.getSummary(),
    fetchCampaignDetails: store.campaigns.fetchCampaignDetails,
  }))
  const [fetchCampaignsApi, apiHandler] = useLazyApiData(fetchCampaigns)
  const [fetchSummaryApi] = useLazyApiData(fetchCampaignsSummary)
  const [getMasterListApi] = useLazyApiData(getMasterList)
  const [fetchCampaignDetaisApi, { state: searchApiState }] = useLazyApiData(fetchCampaignDetails)
  const [filterVisible, setFilterVisible] = useState(false)
  const [fieldSettingVisible, setFieldSettingVisible] = useState(false)
  const [createCampainVisible, setCreateCampainVisible] = useState(false)
  const [detailsVisible, setDetailsVisible] = useState(false)
  const [txnId, setTxnId] = useState('')
  const listData = getCampaigns()
  const { navigate } = useNavigation()

  // useEffect(() => {
  //   if (!createCampainVisible && allPaymentModes?.length > 0) {
  //     //  && allPaymentModes?.length > 0
  //     openCreateCampaign()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [allPaymentModes?.length, masterListApiHandler.state])
  const getEmptyMessage = (): string => {
    return listData.length === 0 ? transactionScreenStrings.noRecords : transactionScreenStrings.empty
  }
  const handleListItemPress = (item: any) => {
    setTxnId(item?.id ?? 'NA')
    navigate(Routes.CAMPAIGN_DETAILS, { id: item.id })
  }

  const handleClose = () => {
    setTxnId('')
    setCreateCampainVisible(false)
  }
  const renderCreateCampaign = (): ReactElement => {
    return (
      <ModBox {...styles.modal} underlayColor="TRANSPARENT">
        <CreateCampaign onClose={handleClose} id={txnId} />
      </ModBox>
    )
  }

  const renderDetials = (): ReactElement => {
    const handleOnClose = () => {
      setTxnId('')
      setDetailsVisible(false)
    }
    const onDuplicate = () => {
      setDetailsVisible(false)
      setCreateCampainVisible(true)
    }
    return (
      <ModBox {...styles.modal} underlayColor="TRANSPARENT">
        <CampaignDetails onClose={handleOnClose} id={txnId} onDuplicate={onDuplicate} />
      </ModBox>
    )
  }

  const renderPortal = (): React.ReactPortal => {
    return ReactDOM.createPortal(renderCreateCampaign(), document.body)
  }

  const renderDetailsPortal = (): React.ReactPortal => {
    return ReactDOM.createPortal(renderDetials(), document.body)
  }

  useEffect(() => {
    if (mid) {
      fetchSummaryApi()
      fetchCampaignsApi()
      getMasterListApi()
    }
  }, [mid, fetchCampaignsApi, fetchSummaryApi, getMasterListApi])

  useEffect(() => {
    if (searchApiState === 'fulfilled' && txnId?.length > 0) {
      navigate(Routes.CAMPAIGN_DETAILS, { id: txnId })
    }
  }, [searchApiState])
  const handleRetry = (): void => {
    if (mid) {
      fetchCampaignsApi()
      fetchSummaryApi()
    }
  }

  const fetchDetailofPath = (): void => {
    if (mid) {
      fetchCampaignsApi()
      fetchSummaryApi()
    }
  }
  const scrollViewStyle = () => {
    if (listData.length === 0) {
      return styles.emptyContainer
    }
    return styles.tableContainer(apiHandler.state === 'pending')
  }
  const scrollStyle = scrollViewStyle()
  const getFutureDate = () => {
    const date = new Date()
    const currentMonth = date.getMonth()
    date.setMonth(currentMonth + 2)
    return date
  }

  const onSearch = (val: string) => {
    if (val?.length > 0) {
      setTxnId(val)
      fetchCampaignDetaisApi(val)
    }
  }

  const isFullScreenScrollable = useRNWindowDimensions()?.height < 543
  return (
    <Box f={1} overflowY={'auto'}>
      {createCampainVisible && renderPortal()}
      {detailsVisible && renderDetailsPortal()}
      <CampaignHighlights />

      <Box {...styles.maincontainer} f={isFullScreenScrollable && listData?.length > 0? undefined: 1}>
        <ActionsMenu
          path={path}
          filterVisible={filterVisible}
          setFilterVisible={setFilterVisible}
          setFieldSettingVisible={setFieldSettingVisible}
          fieldSettingVisible={fieldSettingVisible}
          hideFieldSettings={true}
          fetchDetailOfPath={fetchDetailofPath}
          handleCampaignSearch={onSearch}
          selectedDateInfo={selectedDateInfo}
          updateSelectedDate={updateSelectedDate}
          defaultMaxDate={getFutureDate()}
          scrollToCurrentDate={true}
          maxRange={31}
        />
        <Spacer direction={'vertical'} size={16} />
        <EmptyView
          onRetry={handleRetry}
          isLoading={apiHandler?.state === 'pending'}
          error={apiHandler?.data?.message ?? ''}
          emptyMessage={getEmptyMessage()}
          loadingMessage={transactionScreenStrings.loading}
          hide={(listData.length > 0 && apiHandler?.state !== 'pending') || filterVisible}
          loaderColor={'BLUE'}
        />
        <Box {...scrollStyle} f={1} nativeID={'scroll-horizontal-Table'} minHeight={isFullScreenScrollable && listData?.length > 0 ? 120 : undefined}>
          <NewTable
            data={listData}
            rowHeight={48}
            headerHeight={64}
            customWidthFunc={getCustomColumnWidth}
            tableWidth={viewPortWidth > 1200 ? viewPortWidth - 294 : viewPortWidth}
            headerRowKeys={campaignsTitleData}
            onRowClick={handleListItemPress}
            hide={
              filterVisible ||
              fieldSettingVisible ||
              !((listData.length > 0 && apiHandler?.state !== 'pending') || filterVisible)
            }
          />
        </Box>
        <Spacer direction={'vertical'} size={16} />
      </Box>
    </Box>
  )
}

export default Campaigns
